














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.specificities.SME.workSpace.surface",
        };
    },
    computed: {
        floorAreaWorkspace: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        hasWorkspace: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.specificities.SME.workSpace.exists");
        }
    },
    methods: {
        updateValue: function(floorAreaWorkspace: number): void {
            if (!this.hasWorkspace || (floorAreaWorkspace == 0 && this.floorAreaWorkspace != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaWorkspace});
            }
        }
    }
});

